<template>
    <b-table :items="[item]" :fields="fields" class="disable-bottom-margin" stacked>
        <template slot="openingDate" slot-scope="row">
            {{ $d(row.item.openingDate, 'long') }}
        </template>
        <template slot="closingDate" slot-scope="row">
            {{ row.item.closingDate === 1 ? '-' : $d(row.item.closingDate, 'long') }}
        </template>
        <template slot="blockingDate" slot-scope="row">
            {{ row.item.blockingDate == null ? '-' : $d(row.item.blockingDate, 'long') }}
        </template>
        <template slot="ofdBlockingDate" slot-scope="row">
            {{ row.item.ofdBlockingDate == null ? '-' : $d(row.item.ofdBlockingDate, 'long') }}
        </template>
        <template slot="isBlocked" slot-scope="row">
            <b-form-checkbox :checked="row.item.isBlocked" disabled></b-form-checkbox>
        </template>
        <template slot="isOfdConnected" slot-scope="row">
            <b-form-checkbox :checked="row.item.isOfdConnected" disabled></b-form-checkbox>
        </template>
    </b-table>
</template>

<script>
/* eslint-disable */
export default {
    name: 'kkmDetails',
    props: {
        row: Object
    },
    computed: {
        fields: function () {
            return [
                { key: 'id', label: 'ID' },
                { key: 'sfdNumber', label: this.$t('kkm.kkmSfdNum') },
                { key: 'openingDate', label: this.$t('kkm.openDate') },
                { key: 'closingDate', label: this.$t('kkm.closeDate') },
                { key: 'timezone', label: this.$t('kkm.timezone') },
                { key: 'taxName', label: this.$t('kkm.inspectionName') },
                { key: 'taxCode', label: this.$t('kkm.inspectionCode') },
                { key: 'registrationNumber', label: this.$t('kkm.registration') },
                { key: 'factoryNumber', label: this.$t('kkm.factoryNum') },
                { key: 'isBlocked', label: this.$t('kkm.isBlocked') },
                { key: 'blockingDate', label: this.$t('kkm.blockDate') },
                { key: 'blockingReason', label: this.$t('kkm.blockMessage') },
                { key: 'defaultCashierName', label: this.$t('kkm.defaultOperator') },
                { key: 'defaultCashierCode', label: this.$t('kkm.cashierCode') },
                { key: 'isOfdConnected', label: this.$t('kkm.ofdConnected') },
                { key: 'salePointTitle', label: this.$t('kkm.pointTitle') },
                { key: 'address', label: this.$t('kkm.pointAddress') },
                { key: 'dealerName', label: this.$t('general.dealer') },
                { key: 'dealerIin', label: this.$t('general.iin') },
                { key: 'cashAmount', label: this.$t('kkm.cashAmount') },
                { key: 'ofdBlockingDate', label: this.$t('kkm.ofdBlockDate') },
                { key: 'ofdBlockingReason', label: this.$t('kkm.ofdBlockMessage') }
            ]
        },
        item() {
            return this.row.item;
        }
    }
}
</script>

<style>
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: #007bff;
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
    background-color: #dee2e6;
}
.disable-bottom-margin {
    margin-bottom: 0;
}
</style>
